import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import config from '../../../../../config/config';
import Fetch from '../../functions/Fetch';

export const useIndicators = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [indicatorsTabs, setIndicatorsTabs] = useState([]);

    const sessionSelector = useSelector((state) => {
        return state.core.session;
    });
    const friendly_url = sessionSelector.pdc_project_friendly_url;

    const { has_siasus_dashboard, has_sihsus_dashboard, has_samu_dashboard } = sessionSelector;

    useEffect(() => {
        const loadData = async () => {
            setIsLoading(true);

            if (friendly_url) {
                const indicatorsTabsResponse = await Fetch.post(
                    `${config.endpoints.backend}portal/getallindicators`,
                    { filter: { friendly_url } }
                );

                const initials = [
                    ...(has_siasus_dashboard
                        ? [
                              {
                                  title: 'Produção Ambulatorial',
                                  value: '-1'
                              }
                          ]
                        : []),
                    ...(has_sihsus_dashboard
                        ? [
                              {
                                  title: 'Produção Hospitalar',
                                  value: '-2'
                              }
                          ]
                        : []),
                    ...(has_samu_dashboard
                        ? [
                              {
                                  title: 'SAMU',
                                  value: '-3'
                              }
                          ]
                        : [])
                ];

                if (
                    indicatorsTabsResponse.length > 0 &&
                    !!indicatorsTabsResponse
                ) {
                    setIndicatorsTabs([
                        ...indicatorsTabsResponse.map((tab, index) => ({
                            title: tab.indicator_name,
                            value: index + 1,
                            indicator_link: tab.indicator_link,
                        })),
                        ...initials
                    ]);
                } else {
                    setIndicatorsTabs(initials);
                }
            }

            setIsLoading(false);
        };

        loadData();
    }, [has_siasus_dashboard, has_sihsus_dashboard, friendly_url]);

    return {
        indicatorsTabs,
        isLoading,
    };
};
